"use client";

import { useNode } from "@craftjs/core";
import { getSlugNodeClassName } from "../../slug-node-class";

export function useSlugNodeClassName(slot) {
    const { id } = useNode((node) => ({ id: node.id }));
    return getSlugNodeClassName(id, slot);
}
